module.exports = __webpack_public_path__ + "static/media/connect-logo.7471f31e.svg";